import * as React from "react";
import * as _ from "lodash";
import { IMetricData } from "@curefit/metrics-common";
import { UserGoalView, Goal } from "@curefit/gmf-common";
import IAllergyStaticData from "../../models/staticData/IAllergyStaticData";
import ModelFactory from "../../models/ModelFactory";
import TemplatedList from "../TemplatedList";
import ILifestyleGoal from "../../models/ILifestyleGoal";
import {default as CustomHeader, ICustomHeaderInfo} from "../utils/CustomHeader";
import TextInput from "../TextInput";
import CustomSelect from "../CustomSelect";
import IMetric from "../../models/metrics/IMetric";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import AppUtils from "../../utils/AppUtils";
import ILifeStyleGoal from "../../models/ILifestyleGoal";

let GoalNameHeaderInfos: ICustomHeaderInfo[] = [
    {label: "goal-name", display: "GOAL"}
];

interface HealthTargetsWrapperItemEditorProps {
    goalsType?: string;
    item: UserGoalView;
    staticGoals: Goal[];
    staticMetrics: IMetric[];
    onDataChange: (update: UserGoalView) => any;
    allergiesStaticData: IAllergyStaticData;
    fetchAllergenByName: (allergen: string) => Promise<any>;
    addUserMetric: (metricId: string, metricValue: number) => Promise<any>;
    patientMetrics: {[metricId: number]: IMetricData[]};
    getUserUpdatedMetrics: (metricId: string) => void;
    userId: number;
    secondaryUserId: number;
    isSelf: boolean;
    patientAllSavedMetrics: ILifestyleGoal[];
    setAssessmentMetric?: (metricId: string) => void
}

interface GoalInstance extends Goal {
    _id: string
}

export default class HealthTargetsWrapperItemEditor extends React.Component<HealthTargetsWrapperItemEditorProps> {
    constructor(props: HealthTargetsWrapperItemEditorProps) {
        super(props);
    }
    onGoalMetricRemove = (index: number) => {
        let goalMetrics = Object.assign([], this.props.item.goalMetricTargets);
        goalMetrics.splice(index, 1);
        this.props.onDataChange({ ...this.props.item, goalMetricTargets: goalMetrics });
    }

    onGoalMetricChange = (updatedMetrics: { item: ILifestyleGoal }, index: number) => {
        let currUpdatedGoalMetrics = Object.assign([], this.props.item.goalMetricTargets);
        currUpdatedGoalMetrics[index] = updatedMetrics.item;
        this.props.onDataChange({ ...this.props.item, goalMetricTargets: currUpdatedGoalMetrics});
    }
    generateGoalMetricProp = () => {
        let goalMetricList: { item: ILifestyleGoal }[] = [];
        _.map(this.props.item.goalMetricTargets, (goalMetric, index) => {
            goalMetric.priority = index + 1;
            goalMetricList.push({item: goalMetric as ILifeStyleGoal });
        })
        return goalMetricList;
    }
    generateGoalItems = () => {
        let goalItems: IStaticDataValue[] = [];
        _.map(this.props.staticGoals, (goal: GoalInstance) => {
            goalItems.push({ internalValue: goal._id, displayValue: goal.name });
        })
        return goalItems;
    }
    updateGoalItem = (value: string) => {
        let selectedGoal: Goal = null;
        _.map(this.props.staticGoals, (goal: GoalInstance) => {
            if (goal._id === value) selectedGoal = goal
        });
        let goalName = selectedGoal ? selectedGoal.displayName : null;
        this.props.onDataChange({ ...this.props.item, goalId: value, goalName, goalMetricTargets: null })
    }
    secondaryGoalNameChange = (evt: any) => {
        this.props.onDataChange({ ...this.props.item, goalName: evt.target.value })
    }
    getGoalIdFromGoalName = (goalId: string) => {
        let goals = Object.values(this.props.staticGoals);
        let goalIds = goals.map((item: any) => item._id);
        let index = goalIds.indexOf(goalId);
        if (index !== -1) return goals[index].name;
        else return "";
    }

    _getAllSelectedMetricIds = () => {
        return AppUtils.isDefined(this.props.item) && !_.isEmpty(this.props.item.goalMetricTargets) ? this.props.item.goalMetricTargets.map(item => item.metricId) : [];
    };

    render() {
        console.log("SAVED", this.props.patientAllSavedMetrics)
        let listItems = this.generateGoalMetricProp();
        let selectedGoal = !_.isEmpty(this.props.item.goalId) ? this.getGoalIdFromGoalName(this.props.item.goalId) : null;
        let isGoalFilled = !_.isEmpty(this.props.item.goalId);
        let isGoalCancelled = !_.isEmpty(this.props.item.editInfo) && this.props.item.editInfo.nextStatus === "CANCELLED" ? "cancelled" : "";
        let isGoalNameDisabled = !_.isEmpty(this.props.item._id);
        return <div className={`health-target-goal-item-container ${isGoalCancelled}`}>
            <CustomHeader headerInfos={GoalNameHeaderInfos} rootCls={"patient-goal-name-header"}/>
            {
                this.props.goalsType === "PRIMARY" &&
                <div className={"health-target-goal-name-container"}>
                    {/*<TextInput name={"health-target-goal-name"}/>*/}
                    <CustomSelect dropdownValues={this.generateGoalItems()} selectedValue={selectedGoal} defaultValue={"Select"} updateDropdownValue={this.updateGoalItem} disabled={isGoalNameDisabled}/>
                </div>
            }
            {
                this.props.goalsType === "OTHER" &&
                <div className={"health-target-goal-name-container"}>
                    <TextInput name={"health-target-goal-name"} onChange={this.secondaryGoalNameChange} value={this.props.item.goalName}/>
                </div>
            }
            {
                this.props.goalsType === "PRIMARY" &&
                <TemplatedList 
                    templateName={"healthTarget"} 
                    commonProps={{
                        goalsType: this.props.goalsType,
                        startDate: this.props.item.startEpoch,
                        isGoalFilled,
                        addUserMetric: this.props.addUserMetric,
                        patientMetrics: this.props.patientMetrics,
                        getUserUpdatedMetrics: this.props.getUserUpdatedMetrics,
                        userId: this.props.userId,
                        secondaryUserId: this.props.secondaryUserId,
                        isSelf: this.props.isSelf,
                        allSelectedMetricIds: this._getAllSelectedMetricIds(),
                        isGoalNameDisabled,
                        patientAllSavedMetrics: this.props.patientAllSavedMetrics,
                        setAssessmentMetric: this.props.setAssessmentMetric
                    }}
                    defaultItem={{item: ModelFactory.createNewLifestyleGoal()}}
                    listItems={listItems}
                    onItemRemove={this.onGoalMetricRemove}
                    onItemChange={this.onGoalMetricChange}
                    autoAddNewRow={false} addRowText={"+ Add a metric"}
                />
            }
        </div>
    }
}